import { render, staticRenderFns } from "./ChartSaldo.vue?vue&type=template&id=2a5c3ef8"
import script from "./ChartSaldo.vue?vue&type=script&lang=js"
export * from "./ChartSaldo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports